<template>
    <component
        :is="PanelComponent"
        :searchType="searchType"
        :searchSetting="initSetting"
        :images="settingImages"
        v-bind="panelProps"
        @reset="handleReset"
    >
        <BioSearchSetting
            v-if="!isShort"
            :searchType="BIO_SEARCH_TYPE.short"
            storeKey="upload-short"
            :sequenceType="sequenceType"
            :dbType="dbType"
        />
    </component>
</template>

<script>
import { defineComponent } from 'vue';
import {
    AssistantPreset,
    ShortPreset,
    getShortDefaultAlgorithm,
    getDefaultAlgorithm,
    getDefaultSettings,
} from '@patsnap-biz/bio-search-setting';
import { BIO_SEARCH_TYPE } from '@/constants';

import ungappedExplanationImgEn from '../../../assets/images/bio/preferences_propver_en.png';
import ungappedExplanationImgCn from '../../../assets/images/bio/preferences_propver_cn.png';
import similarityExplanationCn from '../../../assets/images/bio/explanation_cn.png';
import similarityExplanationEn from '../../../assets/images/bio/explanation_en.png';
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default defineComponent({
    name: 'BioSearchSetting',
    components: {
        AssistantPreset,
        ShortPreset,
    },
    props: {
        searchType: {
            type: String,
            required: true,
        },
        storeKey: {
            type: String,
            required: true,
        },
        sequenceType: {
            type: String,
            required: true,
        },
        dbType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            algorithmSettings: null,
        };
    },
    computed: {
        ...mapGetters({
            bioSearchSettingLists: 'bio/searchSettingLists',
        }),
        isShort() {
            return this.searchType === BIO_SEARCH_TYPE.short;
        },
        settingImages() {
            const isCn = this.$i18n.locale === 'cn';
            return {
                similarityExplanation: isCn ? similarityExplanationCn : similarityExplanationEn,
                ungappedExplanation: isCn ? ungappedExplanationImgCn : ungappedExplanationImgEn,
            };
        },
        PanelComponent() {
            if (this.searchType === BIO_SEARCH_TYPE.short) {
                return ShortPreset;
            }
            return AssistantPreset;
        },
        BIO_SEARCH_TYPE() {
            return BIO_SEARCH_TYPE;
        },
        initSetting() {
            let setting = this.bioSearchSettingLists[this.storeKey] || {};
            if (_.isEmpty(setting)) {
                const _setting = _.cloneDeep(this.defaultSetting);
                this['bio/setSearchSetting']({
                    key: this.storeKey,
                    value: _setting,
                });
                setting = _setting;
            }
            return this.appendAlgorithmSettings(setting);
        },
        defaultSetting() {
            return this.appendAlgorithmSettings({
                ..._.cloneDeep(getDefaultSettings(this.searchType)),
                ...this.externalSetting,
            });
        },
        externalSetting() {
            return {
                sequenceType: this.sequenceType,
                dbType: this.dbType,
            };
        },
        externalConfigNames() {
            return ['sequenceType', 'dbType'];
        },
        panelProps() {
            if (!this.isShort) {
                return {};
            }
            return {
                externalConfigNames: this.externalConfigNames,
                externalSetting: this.externalSetting,
            };
        },
    },
    methods: {
        ...mapActions(['bio/setSearchSetting']),
        appendAlgorithmSettings(setting) {
            const algorithmSettings = _.defaults(
                setting?.algorithmSettings || {},
                this.isShort
                    ? getShortDefaultAlgorithm(this.sequenceType, this.dbType) :
                    getDefaultAlgorithm(this.sequenceType, this.dbType),
            );
            return Object.assign(setting, {
                algorithmSettings,
            });
        },
        handleReset() {
            const resetSetting = {};
            Object.assign(resetSetting, _.cloneDeep(this.defaultSetting));
            this['bio/setSearchSetting']({
                key: this.storeKey,
                value: resetSetting,
            });
            this.$emit('reset');
        },
    },
});
</script>

<style lang="scss">

</style>
